// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__-KdcT","box":"style_box__zRD4D","active":"style_active__GV6JH","title":"style_title__Qrn3Q","item":"style_item__DAn7v"};